<template>
  <v-container fluid v-if="asyncDataStatus_ready">
    <div class="dashboard-page">
      <v-card width="100%" class="breadcrumbs mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="
              d-sm-flex
              justify-md-start justify-space-between
              align-center
            "
          >
            <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Pessoas
            </h1>
            <div class="py-6"></div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
            <NovaPessoa v-if="isPermissao"></NovaPessoa>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="12">
          <v-card width="100%" class="support-table ma-1">
            <v-card-text class="pa-0 overflow-x-auto">
              <v-data-table
                :headers="headers"
                :items="items"
                sort-by="nome"
                no-results-text="Nenhuma organização encontrada"
                no-data-text="Não há organizações registradas"
                :items-per-page="itemPerPage"
              >
                <template v-slot:item.nome="{ item }">
                  <span class="mb-0 fs-base"> {{ item.nome }}</span>
                </template>
                <template v-slot:item.authorities="{ item }">
                  <span class="mb-0 fs-base"> {{ _papeis[item.authorities[0]].nome }}</span>
                </template>
                <template v-slot:item.ativo="{ item }">
                  <span class="mb-0 fs-base">{{ item.ativo ? 'Ativo' : 'Inativo' }}</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-right">
                    <v-btn v-if="false && isPermissao" class="mr-2" @click="excluir(item)" color="error text-center" small>Excluir</v-btn>
                    <v-btn v-if="isPermissao" class="mr-2" @click="resetarSenha(item)" color="info text-center" small>Resetar senha</v-btn>
                    <EditaPessoa v-if="isPermissao" :pessoa="item"></EditaPessoa>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <Confirm ref="confirm"></Confirm>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from '@/mixins/asyncDataStatus'
import NovaPessoa from "./Nova/NovaPessoa"
import EditaPessoa from "./Edita/EditaPessoa"
import Confirm from "@/components/Dialog/Confirm";
import moment from "moment";

export default {
  name: "Pessoas",
  components: {
    NovaPessoa,
    EditaPessoa,
    Confirm,
  },
  mixins: [asyncDataStatus],
  data() {
    return {
      headers: [
        { text: 'Nome Completo', value: 'nome' },
        { text: 'E-mail', value: 'email' },
        { text: 'Organização', value: 'organizacao.nome' },
        { text: 'Estado', value: 'estado' },
        { text: 'Papel', value: 'authorities' },
        { text: 'Acesso', value: 'ativo' },
        { text: '', value: 'actions', sortable: false },
      ],
      itemPerPage: 50,
    };
  },
  methods: {
    ...mapActions("usuario", ["fetchAllUsuarios", "deleteUsuario", "redefinirSenha"]),
    ...mapActions("organizacao", ["fetchAllOrganizacoes"]),

    resetarSenha(item) {
      this.$refs.confirm
        .open(
          'Resetar Senha',
          'A senha será resetada para o e-mail.',
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            this.redefinirSenha(item);
          }
        });
    },

    excluir(item) {
      this.$refs.confirm
        .open(
          'Excluir Pessoa',
          item.nome,
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            this.deleteUsuario(item.id);
          }
        });
    },

  },
  computed: {
    computedDate() {
      return this.date ? moment(this.date).format("Do MMM YYYY, dddd") : "";
    },
    items() {
      return this.$store.getters["usuario/all"];
    },

    isPermissao() {
      return this.$store.getters["auth/isAdministrador"];
    },

    _papeis() {
      return this.$store.getters["enums/_papeis"]
    },

  },

  created() {

    Promise.all([
      this.fetchAllUsuarios(),
      this.fetchAllOrganizacoes()
    ]
    )    
    .then(() => { this.asyncDataStatus_fetched() });
  },
};
</script>

<style src="./Pessoas.scss" lang="scss"/>
